import { ref, computed } from 'vue';
import axios from 'axios';
import { Logger } from '@/mixins/logger';

const API_URL = 'https://api.myasuplat-dpl.asu.edu/api/codeset/countries';

// Shared state across all instances
const countries = ref([]);
const loading = ref(false);
const fetched = ref(false);

export function useCountryData() {
  const fetchCountryData = async () => {
    if (fetched.value) return countries.value;

    loading.value = true;
    try {
      const { data } = await axios.get(API_URL, {
        params: { include: 'states', exclude: 'legacyCountryCodes' }
      });
      countries.value = data;
      fetched.value = true;
      return data;
    } catch (err) {
      Logger.methods.logError('useCountryData - Error fetching country data', err);
      throw err;
    } finally {
      loading.value = false;
    }
  };

  const countryOptions = computed(() => countries.value.map((c) => ({ value: c.countryCode, title: c.description })));

  const getStateOptions = (countryCode) => {
    const country = countries.value.find((c) => c.countryCode === countryCode || c.countryCodeTwoChar === countryCode);
    return country?.states?.map((s) => ({ value: s.stateCode, title: s.description })) || [];
  };

  return {
    countries,
    loading,
    fetchCountryData,
    countryOptions,
    getStateOptions
  };
}
